import { useQuery } from '@hooks/reactQuery';

import { getConsistencyCheckExtraPathMoNames } from '@api/consistencyCheckParameters';

import { extractQueryParams } from '@utils/common';
import { optionsFormattedWithArray } from '@utils/formatter';

import { TConsistencyCheckHistoryExtraPathMoNamesDTO } from '@interfaces/cmModule/dto/consistencyCheckDTO';
import { TSelectOption } from '@interfaces/components/componentTypes';

import { EUserRoles } from '@enums/common';

import { refetchOptions } from '@constants/common';
import { CONSISTENCY_CHECK_EXTRA_PATH_MO_NAMES } from '@constants/queryKeys';

interface IUseQueryConsistencyCheckExtraPathMoNamesReturned {
	moNames: TSelectOption<string>[];
	isLoadingMoNames: boolean;
}

const useQueryConsistencyCheckExtraPathMoNames = (
	params: Partial<TConsistencyCheckHistoryExtraPathMoNamesDTO>,
): IUseQueryConsistencyCheckExtraPathMoNamesReturned => {
	const {
		data,
		isInitialLoading,
	} = useQuery<string[], TSelectOption<string>[]>({
		queryKey: [CONSISTENCY_CHECK_EXTRA_PATH_MO_NAMES, params],
		queryFn: extractQueryParams(getConsistencyCheckExtraPathMoNames),
		select: (data) => optionsFormattedWithArray(data),
		enabled: [
			params.dumpConsistencyId,
			params.dataModelPathId,
		],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleViewer,
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		...refetchOptions,
	});

	return {
		moNames: data || [],
		isLoadingMoNames: isInitialLoading,
	};
};

export default useQueryConsistencyCheckExtraPathMoNames;
